import items from "./items";
import login from "./login";

export default {
    items,
    login,
};
